import styles from "./Usuarios.module.css";
import Container from "../../../components/components-ui/Container/Container";
import Button from "../../../components/components-ui/Button/Button";
import api from "../../../services/Api";
import { Grid, Col } from "../../../components/Grid";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useContext, useEffect, useState } from "react";
import { SelectSearch } from "../../../components/components-ui/SelectSearch/SelectSearch";
import { InputMasked } from "../../../components/components-ui/InputMask/InputMask";
import { Box } from "@mui/material";
import Api from "../../../services/Api";
import Loading from "../../../components/components-ui/Loading/Loading";
import { confirmAlert } from "react-confirm-alert";
import { useVerificaPermissao } from "../../../utils/verificaPermissao";
import { AuthContext } from "../../../Provider/AuthContext";

const API_DIREITOS = "/usuario/direitos/index";
const API_PERFIS = "/perfil/index";
const API_PREPOSTO = "/preposto/index";
const API_VEICULOS = "/veiculo/index";
const API_CREATE_USER = "/usuario/create";
const API_UPDATE_USER = "/usuario/update/";
const API_RESET_PASSWORD = "usuario/resetpassword/";
const API_USER = "/usuario/show/";

export default function Action() {
  const { idTipoUsuario } = useContext(AuthContext);
  const verificaPermissao = useVerificaPermissao();

  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const [dataSelect, setDataSelect] = useState({
    preposto: [],
    departamento: [],
    perfil: [],
    veiculos: [],
  });

  useEffect(() => {
    //Verifica se o usuario tem permissao para acessar a tela de usuarios
    verificaPermissao(idTipoUsuario, 65);
  }, []);

  async function getDireitos() {
    await Api.get(API_DIREITOS)
      .then((res) => {
        if (res.data.error === 0) {
          setDataSelect((prevState) => ({
            ...prevState,
            departamento: res.data.data,
          }));
          return;
        }
        toast.error(res.data.msg);
      })
      .catch((error) => console.log(error));
  }

  async function getPerfil() {
    await Api.get(API_PERFIS)
      .then((res) => {
        if (res.data.error === 0) {
          setDataSelect((prevState) => ({
            ...prevState,
            perfil: res.data.data,
          }));
          return;
        }
        toast.error(res.data.msg);
      })
      .catch((error) => console.log(error));
  }

  async function getPreposto() {
    await Api.get(API_PREPOSTO)
      .then((res) => {
        setDataSelect((prevState) => ({
          ...prevState,
          preposto: res.data,
        }));
      })
      .catch((error) => console.log(error));
  }

  async function getVeiculos() {
    await Api.get(API_VEICULOS)
      .then((res) => {
        setDataSelect((prevState) => ({
          ...prevState,
          veiculos: res.data,
        }));
      })
      .catch((error) => console.log(error));
  }

  async function getUser() {
    setIsLoading(true);
    await Api.get(API_USER + id)
      .then((res) => {
        if (res.data.error === 0) {
          setUserData(res.data.data);
          return;
        }
        toast.error(res.data.msg);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Algo de errado aconteceu: " + error.message);
      })
      .finally(() => setIsLoading(false));
  }

  useEffect(() => {
    getDireitos();
    getPerfil();
    getPreposto();
    getVeiculos();

    if (id) {
      getUser();
    }
  }, []);

  async function createUsuario(values) {
    console.log(values);

    const data = {
      Usuario: values.login.toUpperCase(),
      SenhaWeb: values.senha,
      NomeUsuario: values.nome.toUpperCase(),
      IDStatus: values.status,
      IdPreposto: values.preposto,
      IdDepartamento: values.departamento,
      IdPerfil: values.perfil,
      IdPerfilWeb: values.perfil,
      IDVeiculo: values.veiculo,
      NumeroCPF: values.cpf.replace(/[.\-/]/g, ""),
      NumeroRG: values.rg,
      Celular: values.celular,
      Email: values.email,
    };

    await api
      .post(API_CREATE_USER, data)
      .then((res) => {
        console.log(res);
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          navigate("/usina/usuarios");
          return;
        }
        toast.error(res.data.msg);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.msg);
      });
  }

  async function updateUsuario(values) {
    console.log(values);

    const data = {
      Usuario: values.login.toUpperCase(),
      // SenhaWeb: values.senha,
      NomeUsuario: values.nome.toUpperCase(),
      IDStatus: values.status,
      IdPreposto: values.preposto,
      IdDepartamento: values.departamento,
      IdPerfilWeb: values.perfil,
      IDVeiculo: values.veiculo,
      NumeroCPF: values.cpf.replace(/[.\-/]/g, ""),
      NumeroRG: values.rg,
      Celular: values.celular,
      Email: values.email,
    };

    await api
      .post(API_UPDATE_USER + id, data)
      .then((res) => {
        console.log(res);
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          navigate("/usina/usuarios");
          return;
        }
        toast.error(res.data.msg);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.msg);
      });
  }

  function confirmResetPassword() {
    confirmAlert({
      title: "Atenção!",
      message: "Tem certeza que deseja resetar a senha?",
      buttons: [
        {
          label: "Sim",
          onClick: () => resetPassword(),
        },
        {
          label: "Fechar",
        },
      ],
    });
  }

  async function resetPassword() {
    await api
      .get(API_RESET_PASSWORD + id)
      .then((res) => {
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          return;
        }
        toast.error(res.data.msg);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.msg);
      });
  }

  const validadtionSchema = Yup.object().shape({
    login: Yup.string().required("Campo Obrigatório"),
    senha: Yup.string(),
    nome: Yup.string().required("Campo Obrigatório"),
    status: Yup.number().required("Campo Obrigatório"),
    preposto: Yup.number().required("Campo Obrigatório"),
    departamento: Yup.number().required("Campo Obrigatório"),
    perfil: Yup.number().required("Campo Obrigatório"),
    veiculo: Yup.string().when("perfil", {
      is: 4, // verifica se é motorista
      then: (schema) => schema.required("Campo Obrigatório"),
      otherwise: (schema) => schema.notRequired(),
    }),
    cpf: Yup.string(),
    rg: Yup.string(),
    celular: Yup.string(),
    email: Yup.string().email("Formato Inválido"),
  });

  return (
    <Container>
      <h3> {id ? "Edição de Usuario" : "Cadastro de Usuario"} </h3>
      <section className={styles.action_section}>
        <Formik
          enableReinitialize={true}
          initialValues={{
            codigo: !id ? "Novo" : userData?.IDUsuario,
            login: userData?.Usuario || "",
            senha: "123456",
            nome: userData?.NomeUsuario || "",
            status: !id ? 1 : userData?.IDStatus,
            preposto: !id ? 1 : userData?.IdPreposto,
            departamento: userData?.IdDepartamento || null,
            perfil: userData?.IdPerfil || null,
            veiculo: userData?.IdVeiculo || null,
            cpf: userData?.NumeroCPF || "",
            rg: userData?.NumeroRG || "",
            celular: userData?.Celular || "",
            email: userData?.Email || "",
          }}
          validationSchema={validadtionSchema}
          onSubmit={(values) =>
            !id ? createUsuario(values) : updateUsuario(values)
          }
        >
          {({ errors, touched }) => (
            <Form>
              <Box border={1} padding={2}>
                {isLoading && id ? (
                  <div className={styles.loading}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <Grid>
                      <Col size={1}>
                        <label>Código</label>
                        <Field type="text" name="codigo" disabled />
                        {errors.codigo && touched.codigo ? (
                          <span className={styles.alertError}>
                            {errors.codigo}
                          </span>
                        ) : null}
                      </Col>
                      <Col size={3}>
                        <label>Login</label>
                        <Field type="text" name="login" />
                        {errors.login && touched.login ? (
                          <span className={styles.alertError}>
                            {errors.login}
                          </span>
                        ) : null}
                      </Col>
                      <Col size={!id ? 3 : 2}>
                        <label>Senha</label>
                        <Field type="password" name="senha" disabled />
                        {errors.senha && touched.senha ? (
                          <span className={styles.alertError}>
                            {errors.senha}
                          </span>
                        ) : null}
                      </Col>
                      {id && (
                        <Col size={1}>
                          <label>&nbsp;</label>
                          <div
                            className={styles.button_reset}
                            title="Resetar Senha"
                            onClick={confirmResetPassword}
                          >
                            <i
                              className="fas fa-unlock-alt"
                              style={{ color: "white" }}
                            ></i>
                          </div>
                        </Col>
                      )}
                      <Col size={3}>
                        <label>Nome</label>
                        <Field type="text" name="nome" />
                        {errors.nome && touched.nome ? (
                          <span className={styles.alertError}>
                            {errors.nome}
                          </span>
                        ) : null}
                      </Col>
                      <Col size={2}>
                        <label>Status</label>
                        <Field
                          type="number"
                          name="status"
                          component={SelectSearch}
                          options={[
                            {
                              value: 1,
                              label: "Ativo",
                            },
                            {
                              value: 2,
                              label: "Inativo",
                            },
                          ]}
                        />
                        {errors.status && touched.status ? (
                          <span className={styles.alertError}>
                            {errors.status}
                          </span>
                        ) : null}
                      </Col>
                    </Grid>
                    <Grid>
                      <Col size={3}>
                        <label>Preposto</label>
                        <Field
                          type="number"
                          name="preposto"
                          disabled
                          component={SelectSearch}
                          options={dataSelect.preposto.map((item) => ({
                            value: item.IdPreposto,
                            label: item.RazaoSocial,
                          }))}
                        />
                        {errors.preposto && touched.preposto ? (
                          <span className={styles.alertError}>
                            {errors.preposto}
                          </span>
                        ) : null}
                      </Col>
                      <Col size={3}>
                        <label>Departamento</label>
                        <Field
                          type="number"
                          name="departamento"
                          component={SelectSearch}
                          options={dataSelect.departamento.map((item) => ({
                            value: item.IDUsuarioDepartamento,
                            label: item.Departamento,
                          }))}
                        />
                        {errors.departamento && touched.departamento ? (
                          <span className={styles.alertError}>
                            {errors.departamento}
                          </span>
                        ) : null}
                      </Col>
                      <Col size={3}>
                        <label>Perfil Web</label>
                        <Field
                          type="number"
                          name="perfil"
                          component={SelectSearch}
                          // disabled
                          options={dataSelect.perfil.map((item) => ({
                            value: item.IdPerfil,
                            label: item.Perfil,
                          }))}
                        />
                        {errors.perfil && touched.perfil ? (
                          <span className={styles.alertError}>
                            {errors.perfil}
                          </span>
                        ) : null}
                      </Col>
                      <Col size={3}>
                        <label>Veículo</label>
                        <Field
                          type="number"
                          name="veiculo"
                          component={SelectSearch}
                          options={dataSelect.veiculos.map((values) => ({
                            label: values?.placa,
                            value: values?.IDVeiculo,
                          }))}
                        />
                        {errors.veiculo && touched.veiculo ? (
                          <span className={styles.alertError}>
                            {errors.veiculo}
                          </span>
                        ) : null}
                      </Col>
                    </Grid>
                    <Grid>
                      <Col size={2}>
                        <label>CPF</label>
                        <Field name="cpf" maxLength={11}>
                          {({ field }) => (
                            <InputMasked
                              {...field}
                              mask={"999.999.999-99"}
                              maskChar=""
                            />
                          )}
                        </Field>
                        {errors.cpf && touched.cpf ? (
                          <span className={styles.alertError}>
                            {errors.cpf}
                          </span>
                        ) : null}
                      </Col>
                      <Col size={2}>
                        <label>RG</label>
                        <Field name="rg" type="text" maxLength={9} />
                        {errors.rg && touched.rg ? (
                          <span className={styles.alertError}>{errors.rg}</span>
                        ) : null}
                      </Col>
                      <Col size={2}>
                        <label>Celular</label>
                        <Field name="celular" type="text" />
                        {errors.celular && touched.celular ? (
                          <span className={styles.alertError}>
                            {errors.celular}
                          </span>
                        ) : null}
                      </Col>
                      <Col size={6}>
                        <label>E-mail</label>
                        <Field name="email" type="email" />
                        {errors.email && touched.email ? (
                          <span className={styles.alertError}>
                            {errors.email}
                          </span>
                        ) : null}
                      </Col>
                    </Grid>
                    <Grid justifyContent="center" marginTop={2}>
                      <Button type="submit" title={"Salvar"} />
                      <Button
                        type="button"
                        title="Voltar"
                        color="secondary"
                        onClick={() => {
                          navigate("/usina/usuarios");
                        }}
                      />
                    </Grid>
                  </>
                )}
              </Box>
            </Form>
          )}
        </Formik>
      </section>
    </Container>
  );
}
